import { FORM_UPDATE_VALUE } from './actionTypes';

export const changeForm = (value, name) => {
  return({
    type: FORM_UPDATE_VALUE,
    newValue: value,
    name
  });
};



// WEBPACK FOOTER //
// ./src/redux/actions/index.js